import { createSlice } from "@reduxjs/toolkit";
import {
  getSecondFlow,
  createSecondFlow,
  updateSecondFlow,
  deleteSecondFlow,
  clearLocalActiveSecondFlow
} from './actions';

export const initialState = {
  secondFlow: { id: '', email: '', prompt: '', updated_at: '' },
  loading: false
};

const slice = createSlice({
  name: 'secondFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getSecondFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSecondFlow.fulfilled, (state, action) => {
        const { second_flow } = action.payload;
        const secondFlow = { ...state.secondFlow, ...second_flow };
        
        state.loading = false;
        state.secondFlow = secondFlow;
      })
      .addCase(getSecondFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createSecondFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSecondFlow.fulfilled, (state, action) => {
        const { second_flow } = action.payload;
        
        state.loading = false;
        state.secondFlow = second_flow;       
      })
      .addCase(createSecondFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateSecondFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSecondFlow.fulfilled, (state, action) => {
        const { status, second_flow } = action.payload;
        const updatedSecondFlow = { ...state.secondFlow, ...second_flow };
        
        state.loading = false;
        if (status === 204) state.secondFlow = updatedSecondFlow;       
      })
      .addCase(updateSecondFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteSecondFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSecondFlow.fulfilled, (state, action) => {
        const { status } = action.payload;
        
        state.loading = false;
        if (status === 204) state.secondFlow = initialState.secondFlow;       
      })
      .addCase(deleteSecondFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveSecondFlow, state => {
        state.secondFlow = initialState.secondFlow;
      })
  }
})

export default slice.reducer;